import React from 'react';
import { useGallery } from '../hooks/useGallery';
import GalleryGrid from '../components/GalleryGrid';

export default function Galerie() {
  const { photos, loading, error } = useGallery();

  return (
    <main style={styles.page}>
      {/* Page header */}
      <div style={styles.pageHeader}>
        <div style={styles.pageHeaderInner}>
          <span style={styles.eyebrow}>Eindrücke</span>
          <h1 style={styles.heading}>Unsere Galerie</h1>
          <p style={styles.sub}>Bilder sagen mehr als tausend Worte – schauen Sie selbst!</p>
        </div>
        <div style={styles.waveWrapper}>
          <svg viewBox="0 0 1440 60" xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="none" style={{ display: 'block', width: '100%', height: '60px' }}>
            <path d="M0,30 C480,60 960,0 1440,30 L1440,60 L0,60 Z" fill="#f0f7f2"/>
          </svg>
        </div>
      </div>

      <div style={styles.inner}>
        {loading && <p style={styles.info}>Fotos werden geladen...</p>}
        {error && <p style={styles.errorText}>Fotos konnten nicht geladen werden.<br /><small>{error}</small></p>}
        {!loading && !error && <GalleryGrid photos={photos} />}
      </div>
    </main>
  );
}

const styles = {
  page: { backgroundColor: '#f0f7f2', minHeight: '70vh' },
  pageHeader: {
    position: 'relative',
    background: 'linear-gradient(135deg, #1b4332 0%, #2d6a4f 100%)',
    padding: '4rem 1.5rem 5rem',
    textAlign: 'center',
  },
  pageHeaderInner: { maxWidth: '600px', margin: '0 auto', position: 'relative', zIndex: 1 },
  eyebrow: { fontSize: '0.82rem', fontFamily: "'Nunito', Arial, sans-serif", fontWeight: '700', letterSpacing: '2px', textTransform: 'uppercase', color: 'rgba(255,255,255,0.7)' },
  heading: { color: 'white', fontFamily: "'Nunito', Arial, sans-serif", fontSize: 'clamp(2rem,5vw,3rem)', fontWeight: '800', marginTop: '0.4rem', marginBottom: '0.8rem' },
  sub: { color: 'rgba(255,255,255,0.75)', fontFamily: "'Nunito', Arial, sans-serif", fontSize: '1.05rem' },
  waveWrapper: { position: 'absolute', bottom: 0, left: 0, right: 0 },
  inner: { maxWidth: '1200px', margin: '0 auto', padding: '2.5rem 1.5rem 4rem' },
  info: { textAlign: 'center', color: '#40916c', fontFamily: "'Nunito', Arial, sans-serif", padding: '3rem', fontSize: '1.05rem' },
  errorText: { textAlign: 'center', color: '#dc3545', fontFamily: "'Nunito', Arial, sans-serif", padding: '2rem' },
};
